<template>
  <div class="payment-list">
    <ul>
      <li v-for="item in list" v-if="item.type == 1">
        <CheckboxItem v-on:changeItem="changeItem" :item="item" :active="paymentInfo.payment_type_id">
          <div class="payment-content">
            <i class="ico ico-mastercard"></i>
            <span class="card-num">{{item.card_number | cardNumberEncrypt}}</span>
            <span class="card-valid">{{item.valid_date}}</span>
          </div>
        </CheckboxItem>
      </li>
    </ul>
  </div>
</template>

<script>
import api from '../../../services/api.js'
import CheckboxItem from '../../../components/CheckboxItem'

export default {
  name: 'AddressList',
  components: {
    CheckboxItem: CheckboxItem
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  created () {
    this.getPaymentTypeList()
    this.paymentInfo.payment_type_id = this.taskInfo.payment_type_id
  },
  data () {
    return {
      list: null,
      paymentInfo: {
        payment_type_id: null,
        payment_type_info: null
      }
    }
  },
  methods: {
    async getPaymentTypeList () {
      let res = await api.getPaymentTypeList(this)
      this.list = res.body.result
    },
    changeItem (data) {
      this.paymentInfo.payment_type_id = data.item.id
      this.paymentInfo.payment_type_info = data.item
      this.$emit('changePayment', this.paymentInfo)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .payment-list {
    .payment-content {
      padding: 30px 25px;
    }
  }

  .card-num {
    padding: 0 25px 20px;;
  }
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/payment/PaymentList.vue